// extracted by mini-css-extract-plugin
module.exports = {"matrixTable":"matrixTable_matrixTable__3tr2_","cellContent":"matrixTable_cellContent__J_cAi"};